import { useQuery } from '@tanstack/react-query';
import { integrationsLoad } from '../../../../store/Restaurant/api';

export const useGetStoreIntegrations = ({ slug }) => {
    return useQuery(['integrations', slug], () => integrationsLoad({ restaurant_id: slug }));
};
